import React from 'react';
import Styles from './SideBar/sideBar.module.css';

function Shimmer({ type }) {
  return (
    <div>
      {' '}
      {type === 'video' ? (
        <div className={`!mt-[80px] !pl-[25px] ${Styles.grid}`}>
          {Array.from({ length: 10 }).map((_, index) => (
            <div key={index} className={Styles.shimmergridImg} />
          ))}
        </div>
      ) : type === 'categoryvideo' ? (
        <div className={`!mt-[80px] !pl-[25px] ${Styles.gridCate}`}>
          {Array.from({ length: 10 }).map((_, index) => (
            <div key={index} className={Styles.shimmerCate} />
          ))}
        </div>
      ) : (
              <div className={`!mt-[80px] !pl-[25px] ${Styles.gridPhots}`}>
          {Array.from({ length: 40 }).map((_, index) => (
            <div key={index} className={Styles.shimmerPhto} />
          ))}
              </div>
      )}
    </div>
  );
}

export default Shimmer;
